import { Button, Image } from '@outdoor-voices/ui';
import Logo from '@outdoor-voices/ui/dist/components/icons/Logo';
import { useContext } from 'react';
import { OV_EMS_CDN } from '../../../config/theme';
import { OVContext } from '../../../utils/OVContext';
import css from './index.module.scss';
import Strava from './Strava';
import X from './X';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var StravaLeft = function StravaLeft() {
  var _useContext = useContext(OVContext),
      mobileMedium = _useContext.mobileMedium;

  return /*#__PURE__*/_jsxs("div", {
    className: css.left,
    children: [!mobileMedium && /*#__PURE__*/_jsx(Image, {
      alt: "Move Your Body to Free Your Mind",
      height: 2406,
      src: "".concat(OV_EMS_CDN, "media/strava/StravaxOV-Landing-Page-Hero-1.jpg"),
      width: 2091,
      sizes: [320, 700, 1200, 1600],
      wrap: false
    }), mobileMedium && /*#__PURE__*/_jsx(Image, {
      alt: "Move Your Body to Free Your Mind",
      height: 1591,
      src: "".concat(OV_EMS_CDN, "media/strava/OVxStrava-Club-Page-Hero-Mobile.jpg"),
      width: 2500,
      sizes: [320, 700, 1200, 1600],
      wrap: false
    })]
  });
};
export var StravaRightTop = function StravaRightTop() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.header,
      children: [/*#__PURE__*/_jsx(Strava, {}), /*#__PURE__*/_jsx("div", {
        className: css.x,
        children: /*#__PURE__*/_jsx(X, {})
      }), /*#__PURE__*/_jsx("div", {
        className: css.logo,
        children: /*#__PURE__*/_jsx(Logo, {})
      })]
    }), /*#__PURE__*/_jsx("h1", {
      className: css.title,
      children: "Claim Your Reward"
    }), /*#__PURE__*/_jsx("p", {
      className: css.copy,
      children: "Enter your email to receive $25 towards your next purchase of $75+. Plus you\u2019ll be entered to win a $500 Outdoor Voices gift card."
    })]
  });
};
export var StravaRightBottom = function StravaRightBottom() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("p", {
      className: css.signUpTerms,
      children: ["By signing up, you agree to our", ' ', /*#__PURE__*/_jsx("a", {
        href: "/terms",
        target: "_blank",
        rel: "noopener noreferrer",
        children: "Terms of Service"
      }), "."]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.shopBlocks,
      children: [/*#__PURE__*/_jsxs("a", {
        className: css.shopBlock,
        href: "/collections/bestsellers?genderFilter=man",
        rel: "noopener noreferrer",
        target: "_blank",
        children: [/*#__PURE__*/_jsx(Image, {
          alt: "Shop Men",
          height: 348,
          sizes: [298, 400, 600],
          src: "".concat(OV_EMS_CDN, "media/strava/Shop-Mens.jpg"),
          width: 609
        }), /*#__PURE__*/_jsx("div", {
          className: css.shopBlockButton,
          children: /*#__PURE__*/_jsx(Button, {
            white: true,
            buttonIsh: true,
            children: "Shop Men"
          })
        })]
      }), /*#__PURE__*/_jsxs("a", {
        className: css.shopBlock,
        href: "/collections/bestsellers?genderFilter=woman",
        rel: "noopener noreferrer",
        target: "_blank",
        children: [/*#__PURE__*/_jsx(Image, {
          alt: "Shop Women",
          height: 348,
          sizes: [298, 400, 600],
          src: "".concat(OV_EMS_CDN, "media/strava/Shop-Women.jpg"),
          width: 609
        }), /*#__PURE__*/_jsx("div", {
          className: css.shopBlockButton,
          children: /*#__PURE__*/_jsx(Button, {
            white: true,
            buttonIsh: true,
            children: "Shop Women"
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs("p", {
      className: css.terms,
      children: ["Offer valid online and in-store. Enter unique promo code at checkout online or show code to sales associate in-store. Offer expires 4/30/23. Exclusions apply, including but not limited to: Gift Cards, OV Gift Box, and third party merchandise (Merrell, Keen, Wild One, etc). Other exclusions may apply.Cannot be used with any other offer. Cannot be applied to previous orders. Limit one offer per customer for the life of the promotion. Codes are single use only.", ' ', /*#__PURE__*/_jsx("a", {
        href: "/pages/strava-move-your-body-challenge-official-rules",
        rel: "noopener noreferrer",
        target: "_blank",
        children: "See the Official Rules for full details"
      }), "."]
    })]
  });
};